import {createRouter, createWebHistory} from 'vue-router'
import HomePage from '../components/ollaIndex.vue'

import HomePageZh from '../components/zh/ollaIndex.vue'
import HomePageJp from '../components/jp/ollaIndex.vue'

// import HomePageIframe from '../components/ollaIndexiframe.vue'



// 公共路由
export const constantRoutes = [
    {
        path:'/',
        name:'home',
        component:HomePage
    },
    {
        path:'/zh',
        name:'zhhome',
        component:HomePageZh
    },
    {
        path:'/jp',
        name:'jphome',
        component:HomePageJp
    },
    {
        name: "首页",
        path: '/ollaIndex',
        component: () => import('@/components/ollaIndex.vue'),
        meta: {
            title: '您的海外生活助手'
        }
    },
    {
        name: "首页",
        path: '/zh/ollaIndex',
        component: () => import('@/components/zh/ollaIndex.vue'),
        meta: {
            title: '您的海外生活助手'
        }
    },
    {
        name: "首页",
        path: '/jp/ollaIndex',
        component: () => import('@/components/jp/ollaIndex.vue'),
        meta: {
            title: '您的海外生活助手'
        }
    },
    {
        name: "会社概要en",
        path: '/ollaIntro',
        component: () => import('@/components/ollaIntro.vue'),
        meta: {
            title: '您的海外生活助手'
        }
    },
    {
        name: "会社概要zh",
        path: '/zh/ollaIntro',
        component: () => import('@/components/zh/ollaIntro.vue'),
        meta: {
            title: '您的海外生活助手'
        }
    },
    {
        name: "会社概要jp",
        path: '/jp/ollaIntro',
        component: () => import('@/components/jp/ollaIntro.vue'),
        meta: {
            title: '您的海外生活助手'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
})

export default router